import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { HelperService } from '../../../service/helper.service';
import { CustomerManageOrdersService } from '../../../service/cutomer-manage-order.service';
import { EncryptionService } from '../../../service/encryption.service';
import * as FileSaver from "file-saver";
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from '../customDatepicker';
import { orderStatusApproveRejet } from '../order-management-model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class CreateOrderComponent implements OnInit {
  sidebarMenuName: string;
  title = 'Add';
  mode = '';
  id = null;
  orderForm: FormGroup;
  paymentTermsList: any[] = [];
  paymentFilterList: any = [];
  currency: any[] = ['EURO', 'USD'];  // Add your currency options here
  companyList: any[] = [];
  manageCustomerData: any = [];
  customerData: any = [];
  documentInputs: any = [];
  uploadDocumentInputs: any = [];
  setfileids: any = [];
  loginUserId: any;
  today = new Date();
  documentInput: any;
  documentName: any;
  documentInput2: any;
  documentName2: any;
  documentName3: any;
  fileToUpload: any;
  fileToUpload2: any;
  realtimeTitle: any;
  isFileChanged: boolean = false;
  submitted: boolean = false;
  sellingCatalogData: any = [];
  sellingData: any = [];
  sellingCatalogItems: any = [];
  sellingCatalogItemIds: any = [];
  sellingCatalogFilter: any[];
  getSupplierId: any
  orderStatusApproveRejet = orderStatusApproveRejet;

  sellingCatalogSearchControl = new FormControl('');
  sellingCatalogItemSearchControl = new FormControl('');

  constructor(
    private _formBuilder: FormBuilder,
    private helper: HelperService,
    public translate: TranslateService,
    private router: Router, private encryptionService: EncryptionService,
    private route: ActivatedRoute,
    private ApiService: CustomerManageOrdersService,
  ) { }

  ngOnInit(): void {

    this.sideMenuName();
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.loginUserId = JSON.parse(loginUser);
    this.getSellingCatalogListing(this.loginUserId)
    const getsellingCatalogId = localStorage.getItem('sellingCatalogId');
    this.getSupplierId = JSON.parse(getsellingCatalogId)
    // if(this.getSupplierId){
    //   this.getSellingCatalogDetails(this.getSupplierId);
    // }
    this.orderForm = this._formBuilder.group({
      customerId: this.loginUserId,
      proposalId: [''],
      orderName: ['', [Validators.required]],
      completionTime: ['', [Validators.required]],
      description: ['', [Validators.required]],
      taskOrActivties: [''],
      paymentTermsId: [''],
      budget: [''],
      sellingCatalogItemIds: [''],
      attachments: [[]],
      createdBy: 2, // 1 for admin and 2 for customer.,
      sellingCatalogId: [this.getSupplierId ? this.getSupplierId : '']
    });

   this.orderForm.get('sellingCatalogId').valueChanges.subscribe((id) => {
      const sellingCatalogId = id ? id : this.getSupplierId
     if (sellingCatalogId) {
      this.getSellingCatalogDetails(sellingCatalogId);
     }
    });
    this.orderForm.controls['proposalId'].disable()
    const id = this.route.snapshot.paramMap.get('id');
    this.id = id;
    if (id) {
      this.getDetails(id);
      this.title = 'Edit';
      this.orderForm.controls['orderName'].disable();

    } else {

    }
    this.orderForm.controls['budget'].disable();
    this.orderForm.controls['paymentTermsId'].disable();

    this.loadPaymentTerms();
    this.getManageCustomerListing();
  }


  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.title'),
      this.helper.sideMenuListName.next(this.sidebarMenuName);
  }


  formatBytes(bytes: number): string {
    const UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const factor = 1024;
    let index = 0;
    while (bytes >= factor) {
      bytes /= factor;
      index++;
    }
    return `${parseFloat(bytes.toFixed(2))} ${UNITS[index]}`;
  }

  // sideMenuName() {
  //   this.sidebarMenuName = this.id ? 'Edit Order' : 'Add Order';
  //   this.helper.sideMenuListName.next(this.sidebarMenuName);
  // }

  getDetails(id) {
    console.log(this.orderForm.controls['sellingCatalogId'], "Sellnf catalog ies")
    if (id !== '0') {
      this.title = 'Edit';
      this.helper.toggleLoaderVisibility(true);
      this.ApiService.getOrderDetails(id).subscribe((res: any) => {
        if (res.result === true) {
          const orderDetail = res.data;
          console.log(orderDetail.items, "orderDetail items")
          orderDetail.sellingCatalogItemIds = orderDetail.items.map(itemId => itemId._id);
          this.orderForm.reset(orderDetail);
          if (orderDetail?.customerStatus !== this.orderStatusApproveRejet.pending) {
            this.orderForm.controls['sellingCatalogId'].disable();
            this.orderForm.controls['sellingCatalogItemIds'].disable();
          }
          this.helper.toggleLoaderVisibility(false);
          this.getDetailsuploadFile(res.data.attachments);
        } else {
          this.helper.toggleLoaderVisibility(false);
          swal.fire(
            '',
            this.translate.instant(res.reason),
            'error'
          );
        }
      }, (error) => {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(error.message),
          'error'
        );
      });
    }
  }



  getSellingCatalogListing(customerIds: any): any {
    const payload = {
      customerId: customerIds
    }
    this.ApiService.getSellingList(payload).subscribe(
      (res: any) => {
        this.helper.toggleLoaderVisibility(true);
        if (res.result) {
          if (res.data) {
            this.sellingData = res.data;

            this.sellingCatalogData = this.sellingData.slice();
          } else {
            this.sellingCatalogData = [];
          }
          this.helper.toggleLoaderVisibility(false);
        }
      },
      (err: any) => {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(err?.error?.message),
          'info'
        );
      }
    );
  }

  getSellingCatalogDetails(sellingCatalogItemIds: any) {
    console.log('Selling Catalog ID changed:', sellingCatalogItemIds);
    if (sellingCatalogItemIds !== '0') {
      this.ApiService.getSellingCatalogDetails(sellingCatalogItemIds).subscribe((res: any) => {
        if (res.result === true) {
          if (res.data) {
            this.sellingCatalogItems = res.data.catalogList;
            this.sellingCatalogItems.forEach((item) => {
              const unitName = item.sellingCatalogDetails?.unitName || '';
              const taskName = item.sellingCatalogDetails?.taskName || '';
              const macroTaskName = item.sellingCatalogDetails?.macroTaskName || '';
              const customerPrice = item.customerPrice || 0;
              const currency = item.currency == 'EURO' ? '€' : '';
              item.sellingCatalogItemName = `${unitName || taskName || macroTaskName} (${customerPrice} ${currency})`;
            });

            this.sellingCatalogFilter = this.sellingCatalogItems.slice();

            this.helper.toggleLoaderVisibility(false);
          } else {
            this.sellingCatalogItems = [];
          }
        } else {
          this.helper.toggleLoaderVisibility(false);
          swal.fire('', this.translate.instant(res.reason), 'error');
        }
      }, (error) => {
        this.helper.toggleLoaderVisibility(false);
        swal.fire('', this.translate.instant(error.message), 'error');
      });
    }
  }

  loadPaymentTerms() {
    this.ApiService.getAllPaymentList().subscribe((res: any) => {
      if (res.result) {
        this.paymentTermsList = res.data;
        this.paymentFilterList = this.paymentTermsList.slice();
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });
  }

  getDetailsuploadFile(filesIds) {
    const payload = {
      fileIds: filesIds,
    };
    if (filesIds) {
      this.ApiService.getFileDetailsByIds(payload).subscribe((data: any) => {
        if (data) {
          if (!this.isFileChanged) {
            this.documentInputs = data.data;
          } else {
            let Attachments = [...data.data, ...this.documentInputs];
            this.documentInputs = Attachments;
          }

          let combinedAttachments = [...filesIds, ...this.setfileids];
          this.setfileids = combinedAttachments;
        }

      }, (error) => {

      });
    }
  }

  downloadImageFile(id: any, name: any): void {
    this.helper.toggleLoaderVisibility(true);
    this.ApiService.downloadFile(id).subscribe((res: any) => {
      const blob = new Blob([res], { type: 'application/pdf' });
      FileSaver.saveAs(blob, name);
      this.helper.toggleLoaderVisibility(false);
    }, error => {
    });
  }

  uploadFile(files: File[]): void {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append('file', file, file.name);
    });
    if (formData) {
      this.ApiService.uploadFile(formData).subscribe((data: any) => {
        if (data) {
          this.getDetailsuploadFile(data.fileIds)
        }

      }, (error) => {

      });
    }
  }

  maxFileSizeMB = this.helper.maxFileSizeMB; // Max size in MB
  maxFileSizeBytes = this.maxFileSizeMB * 1024 * 1024;

  onFilesChanged(input: HTMLInputElement): void {
    if (input.files) {
      const selectedFiles = Array.from(input.files);

      // Check for file exceeds max size limit
      const oversizedFiles = selectedFiles.filter(file => file.size > this.maxFileSizeBytes);

      if (oversizedFiles.length > 0) {
        this.showSizeExceededPopup();
        input.value = ''; // Clear input value 
        return;
      }

      this.uploadDocumentInputs = [...selectedFiles];
      this.isFileChanged = true;
      this.uploadFile(this.uploadDocumentInputs);
    }
  }

  showSizeExceededPopup(): void {
    const title = this.translate.instant('fileTooLarge.title');
    const body = this.translate.instant('fileTooLarge.body', { maxSize: this.maxFileSizeMB });
    const button = this.translate.instant('fileTooLarge.button');

    Swal.fire({
      title: title,
      text: body,
      icon: 'error',
      confirmButtonText: button
    });
  }

  removeFile(file: File): void {
    const index = this.documentInputs.indexOf(file);
    if (index > -1) {
      this.documentInputs.splice(index, 1);
      // Use a Set to store unique file IDs
      const uniqueAttachments = new Set<number>();
      this.documentInputs.forEach((file) => {
        uniqueAttachments.add(file.id);
      });
      this.setfileids = Array.from(uniqueAttachments);
    }
  }


  addUpdateOrder() {
    if (this.orderForm.valid) {
      let formData = this.orderForm.value;
      formData.attachments = this.setfileids;

      delete formData.sellingCatalog;
      this.helper.toggleLoaderVisibility(true);

      if (this.id) {
        let rawValue = this.orderForm.getRawValue();
        let payload = this.orderForm.value;
        payload.orderName = rawValue.orderName;
        payload.sellingCatalogId = rawValue.sellingCatalogId;
        payload.sellingCatalogItemIds = rawValue.sellingCatalogItemIds;
        payload.id = this.id;
        payload.taskOrActivties = this.orderForm.controls['taskOrActivties'].value ? this.orderForm.controls['taskOrActivties'].value : "";
        payload.budget = this.orderForm.controls['budget'].value ? this.orderForm.controls['budget'].value : "";
        delete payload.createdBy;
        this.ApiService.updateOrder(formData).subscribe(
          (res: any) => {
            this.helper.toggleLoaderVisibility(false);
            if (res.result) {
              this.router.navigate(['/customer-order']);
              swal.fire('', this.translate.instant(res.message), 'success');
            }
          },
          (err) => {
            this.helper.toggleLoaderVisibility(false);
            swal.fire('', this.translate.instant(err.reason), 'info');
          }
        );
      } else {
        this.ApiService.addManageOrder(formData).subscribe(
          (res: any) => {
            this.helper.toggleLoaderVisibility(false);
            if (res.result) {
              this.router.navigate(['/customer-order']);
              swal.fire('', this.translate.instant(res.message), 'success');
            }
          },
          (err) => {
            this.helper.toggleLoaderVisibility(false);
            swal.fire('', this.translate.instant(err.reason), 'info');
          }
        );
      }
    }else{
      this.orderForm.markAllAsTouched();
      this.helper.showMandatoryFieldsPopup();
    }
  }





  public space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }


  getManageCustomerListing(): any {
    this.ApiService.getCustomersList().subscribe(
      (res: any) => {
        this.helper.toggleLoaderVisibility(true);
        if (res.result) {
          if (res.data) {
            this.customerData = res.data;
            this.manageCustomerData = this.customerData.slice();
          } else {
            this.manageCustomerData = [];
          }
          this.helper.toggleLoaderVisibility(false);
        }
      },
      (err: any) => {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(err?.error?.message),
          'info'
        );
      }
    );
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const inputValue = event.target.value;
    if (charCode >= 48 && charCode <= 57) {
      if (inputValue === '' && charCode === 48) {
        event.preventDefault();
        return false;
      }
      return true;
    }
    if (charCode === 32 || (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


}
